import { useTranslation } from "react-i18next";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export default function Welcome() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <Card className="w-full max-w-lg mx-4">
        <CardHeader>
          <h1 className="text-4xl font-bold text-center">
            {t("pages.welcome.welcomeToOnsemblePro")}
          </h1>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Link href="/login">
            <Button size="lg" className="px-8">
              {t("pages.welcome.login")}
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
